import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';

import { IDecisionForm } from '../interfaces/IDecisionForm';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from '../../../KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';

export const convertReasonsFormValueToDecisionData = (values: IDecisionForm): IKnm248['reasons'] => {
  const { reasons } = values;

  if (!reasons) {
    return null;
  }

  return reasons.map(item => ({
    reason: {
      id: item.reason?.id || null,
      guid: item.reason?.guid || null,
      ervkUuid: item.ervkUuid || item.reason?.ervkUuid || null,
      title: item.reason?.title || item.type?.title || null,
      shortTitle: item.reason?.shortTitle || item.type?.shortTitle || null,
      type: item.type ? deleteObjectProperties(item.type, ['label', 'value']) : null,
      text: item.text || null,
      date: convertFormDateValueToKnmDataDate(item.date),
      main: item.reason?.main || null,
      approveRequired: item.reason?.approveRequired || null,
      assignmentNumber: item.assignmentNumber || null,
      assignmentDate: convertFormDateValueToKnmDataDate(item.assignmentDate),
      requirementDetails: item.requirementDetails || null,
      dateRequirement: convertFormDateValueToKnmDataDate(item.dateRequirement),
      dateCreate: item.reason?.dateCreate || null,
      dateBegin: item.type?.dateBegin ? convertFormDateValueToKnmDataDate(item.type.dateBegin) : item.dateBegin || null,
      dateEnd: item.type?.dateEnd ? convertFormDateValueToKnmDataDate(item.type.dateEnd) : item.dateEnd || null,
      links: item.links || null,
      flagProfvizit: typeof item.type?.flagProfvizit === 'boolean' ? item.type.flagProfvizit : null,
      lastConductedKnmDate: convertFormDateValueToKnmDataDate(item.lastConductedKnmDate),
      programAttachment: item.programAttachment || null,
      prosecutorAttachment: item.prosecutorAttachment || null,
      programNumber: item.programNumber || null,
      prescriptionDate: convertFormDateValueToKnmDataDate(item.prescriptionDate),
      prescriptionNumber: item.prescriptionNumber || null,
    },
    order: item.order
      ? {
          ...item.order,
          date: convertFormDateValueToKnmDataDate(item.order.date) || '',
          checkBeginDate: convertFormDateValueToKnmDataDate(item.order.checkBeginDate) || '',
          checkEndDate: convertFormDateValueToKnmDataDate(item.order.checkEndDate) || '',
        }
      : null,
    riskIndicators:
      item.riskIndicators?.map(x => ({
        guid: x.guid,
        indicatorRiskAttachment: convertKnmDocumentAttachmentsFormValuesToKnmData(
          x.indicatorRiskAttachment || undefined,
        ),
        indicatorRiskAuto: x.indicatorRiskAuto || null,
        riskIndicator: x.riskIndicator?.value || null,
        isNew: x.isNew,
      })) || null,
    numGuid: item.numGuid || null,
    dateCreate: item.dateCreate || null,
  }));
};
